//
//
//
//
//
//
//

import AdditionalNewMode from './additionalNewMode.vue';
import AdditionalOldMode from './additionalOldMode.vue';

export default {
  components: { AdditionalNewMode, AdditionalOldMode },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    newMode() {
      return this.event.additionalNewMode;
    },
  },
};
